export default __webpack_public_path__ + "static/media/landing_page_vid_eng.a74b2d13.mp4";